import {
  createUI, toggleAnimation, uiCreated
} from "./gameUI.js";
import {
  startGame,
  stopGame,
  setValuesToInitial,
  startLoading,
  setCenterText,
  pauseFlightWithoutBlast,
  isBlastActive,
  resumeFlightFromElapsed,
  isGameStarted as checkIsGameStarted
} from "./gameLogic.js";

export function gameManager() {
  createUI()
}

//For React Team========================
export function showLoadingScreen() {
  startLoading(5)
}

export function displayPayout(payout, { authoritative = false } = {}) {
  const numPayout = parseFloat(payout)
  if (!Number.isFinite(numPayout)) return
  setCenterText(numPayout.toFixed(2) + 'x', { authoritative })
}

//For React Team========================
export function loadingStopped() {
}

//For React Team========================
export function loadGame() {
}

//For React Team========================
export function resetGame({ preserveMultiplierText = false } = {}) {
  if (!uiCreated) return
  setValuesToInitial({ preserveMultiplierText })
}

// Recovered ON_HOLD: resume/reconstruct at onHoldAt elapsed (not t=0), then paint payout.
export function prepareRecoveredFlight (
  initialPayout,
  { elapsedSeconds = 0, sameRound = false } = {}
) {
  if (!uiCreated) return false
  resumeFlightFromElapsed(elapsedSeconds, { sameRound })
  if (initialPayout != null && Number.isFinite(parseFloat(initialPayout))) {
    displayPayout(initialPayout)
  }
  return true
}

//For React Team========================
export function start() {
  startGame()
}

export function stop() {
  stopGame()
}

export function pauseFlightVisuals() {
  pauseFlightWithoutBlast()
}

export function isFlightBlasted() {
  return isBlastActive()
}

export function setCashoutAmount(num1, num2) {
}

export function changeRocketImg() {
}

export function animationVisibility(toggle = true) {
  toggleAnimation(toggle)
}

export function isGameStarted() {
  return checkIsGameStarted()
}
